import { useNavigate } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    navigate(`/artigo/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const articlesToShow = allArticles.filter(
    (a) => a.slug !== 'cssbuy-sheet-guia-completo'
  );

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-200 text-secondary-700 rounded-full mb-4">
            Blog &amp; Guias
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Artigos e Dicas CSSBuy Spreadsheet
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Tutoriais, comparativos e guias atualizados para ajudar voce a encontrar os melhores produtos.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlesToShow.map((article) => (
            <button
              key={article.slug}
              onClick={() => handleArticleClick(article.slug)}
              className="group text-left bg-background-50 rounded-2xl overflow-hidden border border-secondary-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.readingTime}</span>
                  <span className="text-foreground-300">•</span>
                  <time dateTime={article.date}>
                    {new Date(article.date).toLocaleDateString('pt-BR', {
                      day: 'numeric',
                      month: 'short',
                    })}
                  </time>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-500">
                  <span>Ler artigo</span>
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}